import { INIT, UPDATE_FAIL, UPDATE_SUCCESS } from "../actions/evaluationList";

const initialState = { rows: [], abolitionFlgTexts: [], abolitionFlgValues: [], isDisableMap: {} };

const evaluationList = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT:
      return {
        ...state,
        rows: payload.rows,
        abolitionFlgTexts: payload.abolitionFlgTexts,
        abolitionFlgValues: payload.abolitionFlgValues,
        isDisableMap: payload.isDisableMap
      };
    case UPDATE_SUCCESS:
      return {
        ...state,
        params: payload.params
      };
    case UPDATE_FAIL:
      return {
        ...state,
        message: payload.message
      };

    default:
      return {
        ...state
      };
  }
};

export default evaluationList;
